import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RecentInputState } from '@store/states/recent-input.state';

const recentInputSelector = createFeatureSelector<RecentInputState>('recentInput');
export const recentInputSelectors = {
  all: createSelector(recentInputSelector, (state) => state.all),
};
